
import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionHeading from './SectionHeading';
import { motion } from 'framer-motion';


const skillCategories = [
  {
    icon: (
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" className="text-teal-400"><rect x="3" y="5" width="18" height="4" rx="2" fill="currentColor"/><rect x="3" y="10" width="18" height="4" rx="2" fill="currentColor" opacity=".7"/><rect x="3" y="15" width="18" height="4" rx="2" fill="currentColor" opacity=".5"/></svg>
    ),
    title: "Platform Engineering",
    skills: [
      "Kubernetes",
      "Docker",
      "CRDs & Controllers",
      "AWS",
      "Azure",
      "GCP",
      "Terraform",
      "Ansible",
      "Kustomize",
      "RBAC"
    ]
  },
  {
    icon: (
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" className="text-teal-400"><rect x="4" y="17" width="16" height="2" rx="1" fill="currentColor"/><rect x="4" y="5" width="16" height="2" rx="1" fill="currentColor"/><rect x="4" y="9" width="10" height="2" rx="1" fill="currentColor"/></svg>
    ),
    title: "AI Infrastructure",
    skills: [
      "Kueue",
      "vLLM",
      "GPU Scheduling",
      "MIG / MPS",
      "CUDA",
      "NCCL",
      "KV Cache"
    ]
  },
  {
    icon: (
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" className="text-teal-400"><path d="M4 12h16M12 4v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
    ),
    title: "AI & Distributed Systems",
    skills: [
      "Azure OpenAI",
      "LangGraph",
      "LangChain",
      "RAG",
      "Vector Search",
      "Distributed Systems",
      "TCP/IP",
      "RDMA"
    ]
  },
  {
    icon: (
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" className="text-teal-400"><rect x="5" y="5" width="6" height="6" rx="1" fill="currentColor"/><rect x="13" y="5" width="6" height="6" rx="1" fill="currentColor"/><rect x="5" y="13" width="6" height="6" rx="1" fill="currentColor"/><rect x="13" y="13" width="6" height="6" rx="1" fill="currentColor"/></svg>
    ),
    title: "Reliability & Delivery",
    skills: [
      "Go",
      "Python",
      "Bash",
      "Terraform",
      "Prometheus",
      "Grafana",
      "SLOs / SLIs",
      "PostgreSQL"
    ]
  }
];


const skillVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: {
      delay: i * 0.05,
      duration: 0.3,
      ease: 'easeOut',
    },
  }),
};


export default function Skills() {
  return (
    <AnimatedSection id="skills">
      <SectionHeading number={6}>Technical Arsenal</SectionHeading>
      <div className="flex justify-center">
        <div className="w-24 h-1 bg-teal-400 rounded-full mb-12 mt-2" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {skillCategories.map((cat, idx) => (
          <motion.div
            key={cat.title}
            custom={idx}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={skillVariants}
            className="rounded-2xl p-8 flex flex-col items-start transition duration-300 hover:-translate-y-1"
            style={{ background: 'rgba(15,23,42,0.68)', border: '1px solid rgba(30,41,59,0.8)', boxShadow: '0 18px 50px rgba(0,0,0,0.22)', backdropFilter: 'blur(12px)' }}
          >
            <div className="mb-4">{cat.icon}</div>
            <h3 className="text-xl font-bold text-white mb-4 font-sans">{cat.title}</h3>
            <ul className="space-y-2">
              {cat.skills.map(skill => (
                <li key={skill} className="text-teal-300 text-base font-mono flex items-center">
                  <span className="mr-2 text-teal-400">•</span> {skill}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </AnimatedSection>
  );
}
